import * as format from '@/lib/format';
import Badge from '@/ui/Badge';

import * as Styled from './styled';
import { TEntryDataType } from '@/types';
import * as Icon from '@/ui/Icon';

const hasTabularExtension = (file: File): boolean => {
  const fileExtension = file.name.split('.').pop() || '';
  return ['parquet', 'csv', 'jsonl'].includes(fileExtension);
};

const getDerivedFileType = (file: File): TEntryDataType => {
  if (hasTabularExtension(file)) {
    return 'tabular';
  }
  const fileType = file.type.split('/')[0];
  return (fileType as TEntryDataType) || 'unknown';
};

const FileInfo: React.FC<{ file: File; onRemove: (file: File) => void }> = ({ file, onRemove }) => {
  const dataType = getDerivedFileType(file);
  return (
    <div className="row">
      <div className="data-type">
        <Badge style={{ width: 90 }} variant={dataType}>
          {dataType}
        </Badge>
      </div>
      <div className="filename">
        {file.name} {file.type && `(${file.type})`}
      </div>
      <div className="file-size">
        <Badge icon={false}>{format.humanFileSize(file.size)}</Badge>
      </div>
      <div className="file-remove">
        <Icon.XCircle onClick={() => onRemove(file)} />
      </div>
    </div>
  );
};

const FileList: React.FC<{ files?: File[]; removeFile: (file: File) => void }> = ({ files = [], removeFile }) => {
  return files.length ? (
    <Styled.FileInfoGrid>
      {files.map((file) => (
        <FileInfo key={file.name} file={file} onRemove={removeFile} />
      ))}
    </Styled.FileInfoGrid>
  ) : null;
};

export default FileList;
